import { Theme } from '@material-ui/core'

const paymentStyles = (theme: Theme) => ({
    root: {
        width: '100%',
        maxWidth: 560,
        backgroundColor: theme.palette.background.paper
    },
    paper: {
        width: '90%',
        borderRadius: 35
    },
    formContainer: {
        // padding: '35px 0 15px 0',
        // maxWidth: '550px',
        maxWidth: '1131px',
        width: '80%',
        margin: 'auto',
        padding: '3.5rem 0',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            margin: '0 auto 10em',
            padding: '0.5rem 0 3.5rem'
        }
    },
    modalMobile: {
        [theme.breakpoints.down('sm')]: {
            margin: '20px'
        }
    },
    paymentOption: {
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        flexWrap: 'wrap',
        marginTop: '30px',
        '@media (min-width: 1400px)': {
            width: '85%',
            marginLeft: 'auto',
            marginRight: 'auto' // Adjust the width as per your preference
        },
    } as const,

    paymentCard: {
        // width: '23% '
    },
    buttons: {
        margin: '2rem 0 2rem 0',
        width: '100%',
        [theme.breakpoints.down('sm')]: {
            position: 'fixed',
            bottom: 0,
            margin: 0,
            backgroundColor: '#fff',
            padding: '10px'
        }
    },
    faqButton: {
        padding: 0,
        textTransform: 'none' as const,
        textDecoration: 'underline',
        fontWeight: 600,
        color: '#94004A',
        fontSize: '17px',
        '&:hover': {
            textDecoration: 'underline',
            backgroundColor: 'transparent'
        }
    },
    faqLinkWrapper: {
        display: 'flex',
        justifyContent: 'flex-start',
        marginTop: theme.spacing(2)
    },
    button: {
        // width: '48%',
        [theme.breakpoints.down('sm')]: {
            borderRadius: 0
        }
    },
    buttonGridContainer: {
        width: '47.5%'
    },
    cancelTextButton: {
        color: '#D43838',
        fontSize: '1.375rem',
        height: '65px',
        textTransform: 'none' as const,
        background: 'none',
        boxShadow: 'none',
        fontWeight: 'bold' as const,
        backgroundColor: '#fff',
        '&:hover': {
            background: 'none',
            boxShadow: 'none'
        },
        [theme.breakpoints.down('sm')]: {
            // marginBottom: '100px'
        }
    },
    responsiveWidth: {
        [theme.breakpoints.down('sm')]: {
            padding: '0 2rem'
        }
    },
    leaseContainer: {
        marginTop: '4rem',
        marginBottom: '4.5rem',
        [theme.breakpoints.down('sm')]: {
            marginTop: '3.2rem',
            marginBottom: '2.25rem'
        }
    },
    moversSection: {
        marginTop: '3.6rem',
        [theme.breakpoints.down('sm')]: {
            marginTop: '2rem'
        }
    },
    moversContainer: {
        padding: '40px 30px 47px 41px',
        borderRadius: '20px',
        [theme.breakpoints.down('sm')]: {
            padding: '32px 30px 43px 30px'
        }
    },
    leaseDurationTitle: {
        marginBottom: '2rem',
        [theme.breakpoints.down('sm')]: {
            marginBottom: '1.625rem'
        }
    },
    moversTitle: {
        marginBottom: '1.6rem',
        [theme.breakpoints.down('sm')]: {
            marginBottom: '1.875rem'
        }
    },
    moversField: {
        margin: '1.4rem auto 1.2rem auto',
        '& .react-select__control': {
            padding: '2px 8px',
            borderRadius: '8px'
        },
        '& .react-select__placeholder': {
            fontSize: '16px'
        },
        [theme.breakpoints.down('sm')]: {
            margin: '1.8rem auto 1.625rem auto'
        }
    },
    inlineDatePicker: {
        // border: '2px solid red',
        borderRadius: '8px',
        '& input': {
            paddingLeft: '5px', // Add padding to the left of the input
            // You can add other styles for the input here if needed
        },
    },
    labelText: {
        fontSize: theme.typography.pxToRem(18)
    },
    formLabel: {
        fontSize: theme.typography.pxToRem(20),
        [theme.breakpoints.down('sm')]: {
            fontSize: theme.typography.pxToRem(16),
            marginBottom: '8px'
        }
    },
    calendarInputContainer: {
        padding: '25px 32px 29px 32px',
        [theme.breakpoints.down('sm')]: {
            // padding: '36px 16px 37px 42px'
            padding: '36px 25px 37px 25px;',
            marginBottom: '20px'
        }
    },
    containerStyle: {
        marginLeft: '30px',
        [theme.breakpoints.down('sm')]: {
            marginLeft: '0px'
        }
    },
    sartDateRow: {
        height: '178px',
        alignItems: 'center',
        [theme.breakpoints.down('sm')]: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column'
        }
    },
    stepTwoInfo: {
        '> div': {
            display: 'flex'
        },
        [theme.breakpoints.down('sm')]: {
            display: 'flex',
            flexDirection: 'column'
        }
    },
    stepTwoInfoDetails: {
        display: 'flex',
        [theme.breakpoints.down('sm')]: {
            display: 'flex',
            flexDirection: 'column'
        }
    },
    dialogContanier: {
        paddingTop: '3.875rem',
        paddingBottom: '3.875rem'
    },
    authPrompt: {
        padding: '54px 0',
        marginTop: '55px',
        [theme.breakpoints.down('sm')]: {
            padding: '84px 0'
        }
    },
    applicantInfo: {
        // padding: '54px 0',
        marginTop: '51px',
        [theme.breakpoints.down('sm')]: {
            padding: '2rem 0',
            marginBottom: '7rem'
        }
    },
    authDesc: {
        marginTop: '2rem',
        marginBottom: '3.375rem'
    },
    requiredField: {
        '&:after': {
            content: '"*"',
            color: 'red'
        }
    },
    labelChecker: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        padding: '10px 0',
        [theme.breakpoints.down('sm')]: {
            padding: '15px',
            paddingLeft: '2em',
            paddingRight: '1em',
            marginRight: '0'
        }
    },
    heading: {
        [theme.breakpoints.down('sm')]: {
            fontSize: '1.1rem'
        }
    },
    mBottom: {
        marginBottom: '10px'
    },
    suggestIcon: {
        objectFit: 'contain',
        width: '30px',
        [theme.breakpoints.down('sm')]: {
            marginBottom: '10px'
        }
    } as const,
    paragraphStyle: {
        fontSize: '1.1rem',
        '& span': {
            color: '#94004A'
        },
        [theme.breakpoints.down('sm')]: {
            marginRight: '10px',
            marginLeft: '20px'
        }
    },
    modalSecondaryButton: {
        marginTop: '20px'
    },
    clauseFormContainerGrey: {
        backgroundColor: '#F7F8F9',
        borderRadius: '1.25rem',
        padding: '2rem',
        [theme.breakpoints.down('sm')]: {
            // padding: '0.35rem'
        },
        '@media (max-width: 899px)': {
            padding: '1rem',            
            margin: '0', 
        }
    },
    clauseFormContainer: {
        maxWidth: '80%',
        margin: 'auto',
        padding: '1rem',
        marginTop: '1.5rem',
        [theme.breakpoints.down('md')]: {
            madWidth: '90%',
        },
        [theme.breakpoints.down('xs')]: {
            width: '100%',
            margin: '0',
        },
        '@media (max-width: 899px)': {
            width: '100%', // Apply 100% width for screens smaller than 900px
            margin: '0',
            marginTop: '1.5rem',
            maxWidth: 'none',
            padding: '0rem', // You can customize it as needed
        }
    },
    boldFontWithMargin: {
        fontFamily: 'CircularBold',
        marginTop: '2.5rem'
    },
    boldFont: {
        fontFamily: 'CircularBold',
        marginTop: '0rem'
    },
    publishButton: {
        marginTop: '20px',
        fontSize: '20px',
        borderRadius: '8px',
        paddingTop: '0.7rem',
        width: '100%',
'@media (max-width: 899px)': {
            marginBottom: '1.2rem',
        }
    }
})

export { paymentStyles }